var _path, _circle, _circle2, _path2, _ellipse, _path3, _text, _text2, _ellipse2, _path4, _text3, _text4, _ellipse3, _text5, _ellipse4, _text6, _path5, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatIs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 168 Q200 176 208 168",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 90,
    rx: 35,
    ry: 22,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 105 Q165 115 168 120",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 88,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 14,
    opacity: 0.8
  }, "?")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 96,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.6
  }, "...")), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270,
    cy: 80,
    rx: 38,
    ry: 20,
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242 93 Q235 105 232 112",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 78,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 14,
    opacity: 0.8
  }, "?")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 86,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.6
  }, "...")), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145,
    cy: 55,
    rx: 28,
    ry: 16,
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.4
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 59,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.5
  }, "...")), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 45,
    rx: 25,
    ry: 14,
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.35
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 248,
    y: 49,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.4
  }, "?")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200 100 Q195 85 185 80",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 77,
    r: 4,
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 72,
    r: 3,
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 110,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 50,
    r: 1,
    fill: "#fafcfb",
    opacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 60,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 75,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 225,
    rx: 70,
    ry: 12,
    stroke: "#38bdf8",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIs);
export default __webpack_public_path__ + "static/media/what-is.a4b9bd78d98f4b90a04e6aeb488944da.svg";
export { ForwardRef as ReactComponent };